module.exports = __webpack_public_path__ + "img/colis.6c612306.svg";